export const appName = "Job Scoping Tool";
// TODO we should probably get each project to maintain their own version
export const appVersion = require("../package.json").version;

// HACK
export const appYear = 2021;

export const latestPatch = 2;
export const appVersionKey = "app-version";
